module.exports = __webpack_public_path__ + "img/email.af04a946.svg";